module.exports = __webpack_public_path__ + "img/vwid3-fr.02748844.webp";